import React from 'react';

import DashboardLayout from './../layouts/dashboard';

import Grid from '@material-ui/core/Grid';

import { DriversList } from './../../components/Drivers/DriversList';

export const DriversPage = () => {
  return (
    <DashboardLayout title={'Choferes'}>
      <Grid
        container
        spacing={0}
        direction="row"
        alignItems="flex-start"
        justifyContent="flex-start"
        style={{ minHeight: '100vh' }}
      >
        <Grid item xs>
          <DriversList />
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};
